<template>
  <div class="cp-main-navigation w-full border-t border-b border-gray bg-white mb-6">
    <div class="flex justify-center items-center py-5 space-x-8">
      <router-link
        v-for="item in customerPortalNavigation"
        :key="item.path"
        :to="item.path"
        class="text-lg font-medium text-gray hover:text-red tr-all"
        :class="{ 'text-red': activePath === item.path }">
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">

import { CPRouterPaths } from '@/apps/website/customer-portal/router';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();

const customerPortalNavigation = [
  {
    name: 'Profile',
    path: CPRouterPaths.profilePage,
  },
  {
    name: 'Quotes',
    path: CPRouterPaths.quotesPage,
  },
  {
    name: 'Company Info',
    path: CPRouterPaths.companyInfoPage,
  },
];

const activePath = computed(() => {
  return route.meta.parent || route.path;
});
</script>
